var _path, _path2;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTriangle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 24L1.608 6h20.784L12 24z",
    fill: "#F1F1F1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.765 6.706L12 24 22.235 6.706",
    stroke: "#14191E",
    strokeWidth: 1.3,
    strokeLinejoin: "round"
  })));
}
export default SvgTriangle;